import { MagnifyingGlass, SlidersHorizontal, X } from '@phosphor-icons/react';

type AdminToolbarProps = {
  active: boolean;
  search: string;
  t: any;
  onFilter: () => void;
  onSearch: (value: string) => void;
  showFilter?: boolean;
};

export default function AdminToolbar({
  active,
  search,
  t,
  onFilter,
  onSearch,
  showFilter = true,
}: AdminToolbarProps) {
  return (
    <div className="admin-toolbar">
      <label className="admin-search">
        <MagnifyingGlass />
        <input
          type="text"
          value={search}
          onChange={(event: any) => onSearch(event.target.value)}
          placeholder={t.searchAdmin}
        />
        {search && (
          <button type="button" onClick={() => onSearch('')} aria-label={t.clearSearch}>
            <X />
          </button>
        )}
      </label>
      {showFilter && <button
        type="button"
        className={`admin-filter-button ${active ? 'active' : ''}`}
        onClick={onFilter}
        aria-label={t.sortAndFilter}
      >
        <SlidersHorizontal weight={active ? 'bold' : 'regular'} />
        <span>{t.filters}</span>
        {active && <i />}
      </button>}
    </div>
  );
}
